import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { deleteToken } from './servicio/ServicioManejadorToken';

export class AppTopbar extends Component {

    static defaultProps = {
        onToggleMenu: null
    }

    static propTypes = {
        onToggleMenu: PropTypes.func.isRequired
    }

    logout = () =>{
        localStorage.removeItem("auth");
        deleteToken();
        window.location = '/dif#';
    }

    render() {
        return (
            <div className="layout-topbar clearfix">
                <button className="p-link layout-menu-button" onClick={this.props.onToggleMenu}>
                    <span className="pi pi-bars"/>
                </button>
                <div className="layout-topbar-icons">
                    <button className="p-link" onClick={this.logout}>
                        <span className="layout-topbar-item-text">logout</span>
                        <span className="layout-topbar-icon pi pi-sign-out"/>
                    </button>
                </div>
            </div>
        );
    }
}